import * as React from 'react';

import AddSceneCommandLink from './AddSceneCommandLink';

import DescriptiveTextIcon from '../../../../shared/icons/DescriptiveTextIcon';

import {colors} from '../../../../../styles/variables';

interface Props {
  onPress: () => void;
}

const AddDescriptiveTextShowSceneCommandLink: React.FunctionComponent<
  Props
> = props => {
  const {onPress} = props;
  return (
    <AddSceneCommandLink title={'テキスト'} onPress={onPress}>
      <DescriptiveTextIcon color={colors.textColor} />
    </AddSceneCommandLink>
  );
};

export default React.memo(AddDescriptiveTextShowSceneCommandLink);
